import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
    selector: 'bdo-single-accordion',
    templateUrl: './single-accordion.component.html',
    styleUrls: ['./single-accordion.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SingleAccordionComponent implements OnInit {
  @Input() shortInfo: string = '';
  @Input() arrowRight: boolean = false;
  @Input() isOpenInitially: boolean = false;
  @Input() position: 'left' | 'right' = 'left';
  @Input() buttonStyles: string = '';
  isOpen: boolean = false;
  public buttonId: string = 'single-accordion-button-' + uuidv4();
  public contentId: string = 'single-accordion-panel-' + uuidv4();

  constructor() { }

  ngOnInit() {
    this.isOpen = this.isOpenInitially;
   }

}
